import { RouteConfig } from 'vue-router'
import { ROLE_ADMIN } from '@/utils/constants'

const Page404 = () => import(/* webpackChunkName: "page404" */ '@/views/Page404.vue')
const Page500 = () => import('@/views/Page500.vue')
const Login = () => import('@/views/Login.vue')
const Unauthorized = () => import('@/views/Unauthorized.vue')
const MainContainer = () => import('@/containers/MainContainer.vue')

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: MainContainer,
    redirect: '/editorial-project'
    // children: [
    //   {
    //     path: '/',
    //     name: 'Home',
    //     component: () => import('@/views/Home.vue'),
    //     meta: {
    //       requiresAuth: true,
    //       title: 'page_title.home'
    //     }
    //   }
    // ]
  },
  {
    path: '/template',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Template',
        component: () => import('@/views/Template.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.node_template',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/tools',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Tools',
        component: () => import('@/views/Tools.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.tools',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/editorial-project',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'EditorialProjects',
        component: () => import('@/views/EditorialProjects.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.editorial_projects'
        }
      }
    ]
  },
  {
    path: '/element-type',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'ElementType',
        component: () => import('@/views/ElementTypeView.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.element_type',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/teams',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Teams',
        component: () => import('@/views/Teams.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.teams',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/providers',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Providers',
        component: () => import('@/views/Providers.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.providers',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/production-preps',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'ProductionPreps',
        component: () => import('@/views/ProductionPreps.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.production_preps',
          requiredRole: ROLE_ADMIN
        }
      },
      {
        path: ':id',
        name: 'ProductionPrepDetail',
        component: () => import('@/views/ProductionPrepDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.production_preps',
          requiredRole: ROLE_ADMIN
        }
      }
    ]
  },
  {
    path: '/prep-catalog',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'PrepCatalog',
        component: () => import('@/views/PrepCatalog.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.prep_catalog',
          requiredRole: ROLE_ADMIN
        }
      }
    ]
  },
  {
    path: '/buildings',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Buildings',
        component: () => import('@/views/Buildings.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.buildings',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/business-units',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'BusinessUnits',
        component: () => import('@/views/BusinessUnits.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.business_units',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/companies',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Companies',
        component: () => import('@/views/Companies.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.companies',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/account-metadata-fields',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'AccountMetadataFields',
        component: () => import('@/views/AccountMetadataFields.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.account_metadata_fields',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/controlled-vocabulary',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'ControlledVocabulary',
        component: () => import('@/views/ControlledVocabulary.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.controlled_vocabulary',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/apps',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Apps',
        component: () => import('@/views/Apps.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.apps',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/resources',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Resources',
        component: () => import('@/views/Resources.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.resources',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/accounts',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Accounts',
        component: () => import('@/views/Accounts.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.accounts',
          requiredProfiles: ['ADMIN', 'MANAGER']
        }
      },
      {
        path: '/accounts/:accountId',
        name: 'AccountDetail',
        component: () => import('@/views/AccountDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.account_detail',
          requiredProfiles: ['ADMIN', 'MANAGER']
        }
      }
    ]
  },
  {
    path: '/project',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Project',
        component: () => import('@/views/Project.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.project',
          requiredProfiles: ['ADMIN']
        }
      }
    ]
  },
  {
    path: '/tracing',
    component: MainContainer,
    children: [
      {
        path: '/',
        name: 'Tracing',
        component: () => import('@/views/Tracing.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.tracing'
        }
      }
    ]
  },
  {
    path: '/product',
    component: MainContainer,
    children: [
      {
        path: '/product',
        name: 'Products',
        component: () => import('@/views/Products.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.product'
        }
      },
      {
        path: '/product/:productId',
        name: 'ProductDetail',
        component: () => import('@/views/ProductDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'page_title.product_detail'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'page_title.login'
    }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
    meta: {
      title: 'page_title.unauthorized'
    }
  },
  {
    path: '/500',
    name: 'Page500',
    component: Page500
  },
  {
    path: '/:catchAll(.*)',
    name: 'Page404',
    component: Page404
  }
]

export default routes
